export const customerContactMethods = {
  email: 'email',
  url: 'url',
  emailAndUrl: 'email_and_url',
}

export const customerContactMethodsOptions = [
  { value: customerContactMethods.email, label: 'Email de contacto para clientes' },
  { value: customerContactMethods.url, label: 'URL de contacto para clientes' },
  { value: customerContactMethods.emailAndUrl, label: 'Email & URL de contacto para clientes' },
]
